import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Input,
  Form,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import CustomTable from "Custom/TableWithRemotePagination"
import * as Yup from "yup"
import { Field, FormikProvider, useFormik } from "formik"
import CustomSelect from "Custom/CustomSelect"
import { Spin } from "antd"
import { get } from "helpers/api_helper"
import { GET_ORG_INVOICE_LIST } from "helpers/url_helper"
import InvoiceDetails from "./invoiceDetails"
import { columns } from "./columns"

const BillListOrganisation = () => {
  const navigate = useNavigate()
  const [totalSize, setTotalSize] = useState(0)
  const [hide, setHide] = useState(null)
  const [listOfInvoice, setListOfInvoice] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [search, setSearch] = useState("")
  const [invoiceData, setInvoiceData] = useState([])
  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true)
    get(
      GET_ORG_INVOICE_LIST +
      "?organization_id=1" +
      "?page=" +
      page +
      "&paginate=" + sizePerPage +
      (search ? "&search=" + search : "") +
      (SearchByColumn ? "&column_filter=" + SearchByColumn : "") +
      (Status ? "&status_filter=" + Status : "")
    )
      .then(res => {
        if (res?.data?.data?.length > 0) {
          setListOfInvoice(res?.data?.data?.map((e) => {
            return {
              Date: e?.invoice?.invoice_date,
              Status: e?.v_invoice_status,
              BillNo: <Link onClick={() => { setHide(e?.v_invoice_id) }}>
                {e?.invoice?.invoice_no}
              </Link>,
              VendorName: e?.contact?.display_name,
              Amount: e?.invoice?.grand_total,
            }
          }))
          setInvoiceData(res.data.data)
          setTotalSize(res?.data?.total)
        } else {
          setPackageList([])
          setTotalSize(0)
        }
      })
      .catch(error => {
        console.log(error)
      })
    setIsLoading(false)
  }

  useEffect(() => {
    getData()
  }, [])

  const validationSchemaFilter = Yup.object().shape({})

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Status: "",
      // Search: "",
      SearchByColumn: "",
    },
    validateOnBlur: false,
  })
  const {
    setFieldValue,
    values: { Search, Status, SearchByColumn },
  } = formikFilter

  const handleValidSubmitFilter = values => { }

  const billOptions = [
    { label: "Bill No.", value: 1 },
    { label: "Vendor Name", value: 2 },
    { label: "Sales Order No.", value: 3 },
  ]

  const statusOption = [
    { label: "All", value: 0 },
    { label: "Draft", value: 1 },
    { label: "Sent", value: 2 },
    { label: "Paid", value: 3 },
  ]


  return (
    <React.Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="page-content">
          <MetaTags>
            <title>{"Bills"} | Katlax OMS</title>
          </MetaTags>

          <Container fluid>
            {hide === null ? (
              <>
                <Row className="mt-3">
                  <Col lg={6}>
                    <div className="mt-2" style={{ fontSize: "large" }}>
                      <b>Bills</b>
                    </div>
                  </Col>
                  <Col lg={6} style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        navigate("/add-bill-organisation")
                      }}
                    >
                      Add Bill
                    </button>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col className="col-12">
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row>
                          <Col lg={12}>
                            <Row>
                              <Col lg={3} sm={6} md={3}>
                                <div className="form-group has-search">
                                  <span className="fa fa-search form-control-feedback"></span>
                                  <Input
                                    type="text"
                                    name="Search"
                                    className="form-control"
                                    placeholder="Search"
                                    value={search}
                                    onChange={e => {
                                      setSearch(e.target.value)
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col lg={2} sm={6} md={2}>
                                <Field
                                  name="SearchByColumn"
                                  placeholder={"By Column"}
                                  component={CustomSelect}
                                  options={billOptions}
                                />
                              </Col>
                              <Col lg={2} md={2}>
                                <Field
                                  name="Status"
                                  placeholder={"Status"}
                                  component={CustomSelect}
                                  options={statusOption}
                                />{" "}
                              </Col>
                              <Col
                                lg={2}
                                className="mt-1"
                                style={{ textAlign: "left" }}
                              >
                                <div
                                  onClick={() => {
                                    setSearch("")
                                    formikFilter.setFieldValue("Status", "")
                                    // formikFilter.setFieldValue("Search", "")
                                    formikFilter.setFieldValue(
                                      "SearchByColumn",
                                      ""
                                    )
                                  }}
                                >
                                  <i
                                    className="mdi mdi-filter-remove"
                                    style={{
                                      fontSize: "20px",
                                      color: "#4a539f",
                                    }}
                                  ></i>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                    <Card>
                      <CardBody>
                        <CustomTable
                          keyField="Bill"
                          columns={columns}
                          data={listOfInvoice}
                          totalSize={totalSize}
                          getData={getData}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <InvoiceDetails setHide={setHide}
                  id={hide} data={invoiceData} />
              </>
            )}
          </Container>
        </div>
      </Spin>
    </React.Fragment>
  )
}
BillListOrganisation.propTypes = {
  t: PropTypes.any,
}

export default withRouter(withTranslation()(BillListOrganisation))
